<mat-form-field class="w-full" [class.invalid]="!control.disabled && control.touched && control.errors">
  <mat-label>{{ caption }}</mat-label>
  <mat-chip-grid class="p-4" #chipList [required]="required" [formControl]="control">
    @for (chip of control.value ?? []; track chip; let i = $index) {
      <mat-chip-row [value]="chip" [selectable]="false" [selected]="false" [removable]="true" (removed)="removeChip(i)">
        {{ chipMask ? (getCaption(chip, 'chip') | localize) : chip.displayName }}
        @if (!readonly) {
          <mat-icon class="icon-size-5" matChipRemove [svgIcon]="'heroicons_solid:minus-circle'"></mat-icon>
        }
      </mat-chip-row>
    }
    <input [matChipInputFor]="chipList" [placeholder]="placeholder" [matChipInputAddOnBlur]="true" [formControl]="searchCtrl" [readonly]="readonly"
      [matChipInputSeparatorKeyCodes]="separators" (matChipInputTokenEnd)="add($event)" [matAutocomplete]="ac">
      <mat-autocomplete #ac="matAutocomplete" (optionSelected)="selected($event)" [displayWith]="displayFn">
        @for (option of option; track option) {
          <mat-option [value]="option">
            {{ optionMask ? (getCaption(option, 'option') | localize) : option.caption }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-chip-grid>
    @if (!control.disabled && control.touched && control.errors) {
      <mat-error>
        @if (control.errors?.validateArrayNotEmpty) {
          {{ 'errorRequiredField' | transloco }}
        }
        @if (control.hasError('minlength')) {
          {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength } }}
        }
        @if (control.hasError('maxlength')) {
          {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength } }}
        }
      </mat-error>
    } @else if (hint) {
      <mat-hint>{{ hint }}</mat-hint>
    }
  </mat-form-field>